import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Home from './pages/Home'
import Services from './pages/Services'
import About from './pages/About'
import Contact from './pages/Contact'
import AnalyticsReporting from './pages/AnalyticsReporting'
import SaasDevelopment from './pages/SaasDevelopment'
import ContentMarketing from './pages/ContentMarketing'
import EmailMarketing from './pages/EmailMarketing'
import GoogleFacebookAds from './pages/GoogleFacebookAds'
import SeoStrategy from './pages/SeoStrategy'
import SocialMediaCampaigns from './pages/SocialMediaCampaigns'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import Webinars from './pages/Webinars'
import CaseStudies from './pages/CaseStudies'
import Guides from './pages/Guides'
import CookiePolicy from './pages/CookiePolicy'
import Careers from './pages/Careers'
import NotFound from './pages/NotFound';

import { logPageView } from './services/analytics'
import ScrollToTop from './components/ScrollToTop'

function App() {
  return (
    <Router>
      <RouteChangeTracker />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/analytics-reporting" element={<AnalyticsReporting />} />
        <Route path="/saas-development" element={<SaasDevelopment />} />
        <Route path="/content-marketing" element={<ContentMarketing />} />
        <Route path="/email-marketing" element={<EmailMarketing />} />
        <Route path="/google-facebook-ads" element={<GoogleFacebookAds />} />
        <Route path="/seo-strategy" element={<SeoStrategy />} />
        <Route path="/social-media-campaigns" element={<SocialMediaCampaigns />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/webinars" element={<Webinars />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="*" element={<NotFound />} />   {/* catch-all 404 */}
      </Routes>
    </Router>
  )
}


// Component to track route changes
function RouteChangeTracker() {
  const location = useLocation()
  useEffect(() => {
    logPageView(location.pathname + location.search)
  }, [location])
  return null
}

export default App